import { UserIcon } from "@/assets/icons";
import { strings } from "@/constants";
import type { CompanyType } from "@/types";

export const CompanyDetailHeader = ({ company }: { company: CompanyType }) => (
    <div
        className="
            flex
            flex-col
            gap-3
            border-b
            border-gray-200
            px-4
            py-4
            sm:flex-row
            sm:items-center
            sm:gap-4
            sm:px-6
            sm:py-6
        "
    >
        <div
            style={{ background: "linear-gradient(135deg, #1356BC 0%, #0025BA 100%)" }}
            className="
                flex
                h-16
                w-16
                shrink-0
                items-center
                justify-center
                rounded-full
                text-white
                shadow-md
            "
        >
            <UserIcon className="h-8 w-8" />
        </div>
        <div className="min-w-0 flex-1">
            <h1
                className="
                    truncate
                    text-xl
                    font-bold
                    text-text-primary
                    sm:text-2xl
                "
            >
                {company.name}
            </h1>
            <p className="truncate text-sm text-text-secondary">{company.email}</p>
        </div>
        <span
            className={`
                shrink-0
                self-start
                rounded-full
                px-3
                py-1
                text-xs
                font-semibold
                tracking-wide
                uppercase
                sm:self-auto
                ${company.isEnabled ? "bg-primary text-white" : "bg-error text-white"}
            `}
        >
            {company.isEnabled ? strings.admin.statusEnabled : strings.admin.statusDisabled}
        </span>
    </div>
);
